class Recruitments {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    let tabChange = this.tabChange.bind(this);
    $('.js-tab-trigger > div').click(function() {
      tabChange(this);
    });

    if (this.getUrlParam('tab')) {
      tabChange($('.js-tab-trigger > div').eq(this.getUrlParam('tab') - 1)[0]);
    }
  }

  tabChange(el) {
    el.classList.add('is-active');
    el.parentElement.querySelectorAll('div').forEach(sibling => {
      if (sibling !== el) sibling.classList.remove('is-active');
    });

    document.querySelectorAll('.tab-pane').forEach(pane => {
      pane.style.display = 'none';
    });
    document.getElementById('category-' + el.dataset.category).style.display = 'block';
  }
  
  getUrlParam(param) {
    // クエリストリングを取得し、パラメータを分解
    var pageUrl = window.location.search.substring(1);
    var urlVariables = pageUrl.split('&');
    
    // 各パラメータをループして目的のパラメータを探す
    for (var i = 0; i < urlVariables.length; i++) {
        var parameterName = urlVariables[i].split('=');
        
        // 指定されたパラメータが見つかった場合、その値を返す
        if (parameterName[0] === param) {
            return parameterName[1] === undefined ? true : decodeURIComponent(parameterName[1]);
        }
    }
    
    // 指定されたパラメータが見つからない場合、nullを返す
    return null;
  }
}